module.exports = __webpack_public_path__ + "assets/img/18_1784_big.023a4bc5.jpg";